// extracted by mini-css-extract-plugin
export default {"button":"DPButton_button__MFxQj","buttontext":"DPButton_buttontext__jWghE","buttoninner":"DPButton_buttoninner__071pd","buttontextabsolute":"DPButton_buttontextabsolute__xwOvK"};